import * as db from '../../db'
import _ from 'lodash'

export const SELECT_COMPANY = 'SELECT_COMPANY'
export const LOADING_COMPANIES = 'LOADING_COMPANIES'
export const RECEIVE_COMPANIES = 'RECEIVE_COMPANIES'
export const SET_INSTALLERS = 'SET_INSTALLERS'
export const SET_DEFAULT_NVR = 'DEFAULT_BUNDLE'
export const CLEAR_NVR = 'CLEAR_NVR'

// Init State Object
const state = {
  loading: false,
  companies: {},
  selectedCompany: undefined,
  installers: [],
  defaultNVR: ''
}

// Getters
const getters = {
  companies: state => _.values(state.companies),
  loading: state => state.loading,
  installers: state => state.installers,
  selectedCompany: state => state.selectedCompany,
  defaultNVR: state => state.defaultNVR
}

// Actions
const actions = {
  getCompanies({ commit }) {
    commit(LOADING_COMPANIES, true)
    db.companies.onSnapshot(function(snapshot) {
      let companies = {}
      snapshot.forEach(doc => {
        let company = doc.data()
        company.id = doc.id
        companies[company.id] = company
      })
      commit(SET_INSTALLERS, { companies })
      commit(RECEIVE_COMPANIES, { companies })
    })
    commit(LOADING_COMPANIES, false)
  },

  selectCompany({ commit }, selectedCompany) {
    commit(SELECT_COMPANY, selectedCompany)
  },

  createCompany({ commit }, company) {
    commit(LOADING_COMPANIES, true)
    var newCompany = {
      companyName: company.companyName,
      companyType: company.companyType,
      associatedProjects: company.associatedProjects,
      brands: company.brands
    }
    db.companies
      .add(newCompany)
      .then(data => {
        console.log(data)
        commit(LOADING_COMPANIES, false)
      })
      .catch(e => {
        console.log(e)
        commit(LOADING_COMPANIES, false)
      })
  },

  updateCompany({ commit }, company) {
    db.companies
      .doc(company.id)
      .update({
        companyName: company.companyName,
        companyType: company.companyType,
        associatedProjects: company.associatedProjects,
        brands: company.brands
      })
      .catch(e => {
        console.log(e)
        commit(LOADING_COMPANIES, false)
        return
      })
  },

  deleteCompany({ commit }, company) {
    db.companies.doc(company.id).delete()
  },

  async lookupDefaultsByCompany({
    commit
  }, requestedData) {
    console.log("TCL: lookupAdditionalProductByCompany -> defaultName", requestedData.defaultName, "companyName", requestedData.companyName)
    let companyData = ''
    try {
      const company = await db.companies
        .where("companyName", "==", requestedData.companyName)
        .get()

      company.forEach(function (doc) {
        companyData = doc.data()
        console.log("TCL: lookupDefaultsByCompany -> companyData", JSON.stringify(companyData, null, 4))
        _.mapKeys(companyData.defaults, function (value, key) {
          if (key === requestedData.defaultName) {
            console.log("TCL: lookupDefaultsByCompany -> value", value, "key", key)
            // ** TODO ** add if-else statements for other defaults **
            commit(SET_DEFAULT_NVR, value)
          }
        })
      })
    } catch (error) {
      console.log("TCL: lookupDefaultsByCompany -> error", error)
    }
  },

  clearNVR( {commit} ) {
    commit(CLEAR_NVR)
  }
}

// Mutations (Setters)
const mutations = {
  [LOADING_COMPANIES](state, value) {
    state.loading = value
  },

  [RECEIVE_COMPANIES](state, { companies }) {
    state.companies = companies
  },

  [SET_INSTALLERS](state, { companies }) {
    let installerArray = []
    Object.entries(companies).forEach(([key, value]) => {
      if (installerArray.indexOf(value.companyName) === -1 && value.companyType === 'Installer') {
        installerArray.push(value.companyName)
      }
    })
    installerArray.filter(installer => {
      if (installer !== null) {
        return installer
      }
    })
    state.installers = installerArray
  },

  [SELECT_COMPANY](state, selectedCompany) {
    state.selectedCompany = selectedCompany
  },

  [SET_DEFAULT_NVR](state, bundleId) {
    state.defaultNVR = bundleId
  },

  [CLEAR_NVR] (state) {
    state.defaultNVR = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/company.js